
import Swiper from "swiper";
import { Navigation, Keyboard, Autoplay } from "swiper/modules";
// import customSelect from "../modules/select";
import '../modules/consultationForm';
import { searchMBA } from '../modules/exploreSection.js';
import {setAdBannersforMobOrDesk} from '../modules/banners';
import { lazyLoadBackgrounds } from '../modules/lazyLoadBackgrounds';
import testimonialsSlider from '../modules/testimonials';
import rankingSchoolsGrid from '../modules/rankingSchoolsGrid';
import fitTooltips from '../modules/fitTooltips';

function toolsSlider() {
    const toolsContainer = document.querySelector('[data-module="tools-slider"]');

    if (toolsContainer) {
        const toolsConfig = {
            modules: [Navigation, Keyboard, Autoplay],
            // direction: 'vertical',
            loop: true,
            slidesPerView: 1,
            spaceBetween: 25,
            initialSlide: toolsContainer.dataset.initialSlide,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            autoplay: {
                delay: 5000,
                pauseOnMouseEnter: true,
            },
            navigation: {
                nextEl: ".tools .unm-slider-btn-next",
                prevEl: ".tools .unm-slider-btn-prev",
            },
        };

        const toolsSwiper = new Swiper(`[data-module="tools-slider"] .swiper`, toolsConfig);

        return toolsSwiper;
    }
}

function schoolsSlider() {
    const schoolsContainer = document.querySelector(
        '[data-module="schools-slider"]'
    );

    if (schoolsContainer) {
        const slideCount = schoolsContainer.querySelectorAll('.swiper-slide').length;

        const schoolsConfig = {
            modules: [Navigation, Keyboard, Autoplay],
            loop: true,
            slidesPerView: 1,
            spaceBetween: 25,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            autoplay: {
                delay: 5000,
                pauseOnMouseEnter: true,
            },
            breakpoints: {
                // when window width is >= 768px
                768: {
                    slidesPerView: 2,
                    spaceBetween: 25,
                    loop: slideCount > 2 ? true : false,
                },
                // when window width is >= 1200px
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 25,
                    loop: slideCount > 4 ? true : false,
                },
            },
            navigation: {
                nextEl: '[data-module="schools-slider"] .unm-slider-btn-next',
                prevEl: '[data-module="schools-slider"] .unm-slider-btn-prev',
            },
            watchOverflow: true,
        };

        const schoolsSwiper = new Swiper(
            '[data-module="schools-slider"] .swiper',
            schoolsConfig
        );
        return schoolsSwiper;
    }
}

function careersSlider() {
    const careersContainer = document.querySelector(
        '[data-module="careers-slider"]'
    );

    if (careersContainer) {
        const slideCount = careersContainer.querySelectorAll('.swiper-slide').length;

        const careersConfig = {
            modules: [Navigation, Keyboard, Autoplay],
            // direction: 'vertical',
            loop: true,
            slidesPerView: 1,
            spaceBetween: 25,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            autoplay: {
                delay: 3000,
                pauseOnMouseEnter: true
            },
            breakpoints: {
                // when window width is >= 768px
                768: {
                    slidesPerView: 2,
                    spaceBetween: 25,
                    loop: slideCount > 2 ? true : false,

                },
                // when window width is >= 1224px
                1224: {
                    slidesPerView: 4,
                    spaceBetween: 25,
                    loop: slideCount > 4 ? true : false,
                }
            },
            pagination: {
                el: '.career-opportunities-articles .swiper-pagination',
            },
            navigation: {
                nextEl: '.career-opportunities-articles .unm-slider-btn-next',
                prevEl: '.career-opportunities-articles .unm-slider-btn-prev',
            },
            watchOverflow: true,
        }

        const careerArticlesSwiper = new Swiper('[data-module="careers-slider"] .swiper', careersConfig);
        return careerArticlesSwiper;
    }
}

function countriesSlider() {
    const countriesContainer = document.querySelector(
        '[data-module="countries-slider"]'
    );

    if (countriesContainer) {
        const slideCount = countriesContainer.querySelectorAll('.swiper-slide').length;

        const countriesConfig = {
            modules: [Navigation, Keyboard, Autoplay],
            loop: true,
            slidesPerView: 1,
            spaceBetween: 25,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            autoplay: {
                delay: 5000,
                pauseOnMouseEnter: true,
            },
            breakpoints: {
                // when window width is >= 768px
                768: {
                    slidesPerView: 2,
                    spaceBetween: 25,
                    loop: slideCount > 2 ? true : false,

                },
                // when window width is >= 1200px
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 25,
                    loop: slideCount > 4 ? true : false,
                },
            },
            navigation: {
                nextEl: '[data-module="countries-slider"] .unm-slider-btn-next',
                prevEl: '[data-module="countries-slider"] .unm-slider-btn-prev',
            },
            watchOverflow: true,
        };

        const countriesSwiper = new Swiper(
            '[data-module="countries-slider"] .swiper',
            countriesConfig
        );
        return countriesSwiper;
    }
}

const el = {
  articlesContainer: document.querySelector('[data-component="articles-list"]'),
  path: document.querySelector('[data-component="articles-list"]')?.dataset.path,
  searchBtn: document.querySelector('[data-action="search"]'),
  searchInput: document.querySelector('[data-element="search-box"] input'),
  skeleton: document.querySelector('.skeleton-loader'),
  mobSearchBtn: document.querySelector('.mob.search-btn'),
  mobFiltersBtn: document.querySelector('.mob.filters-btn'),
}
let filters = JSON.parse(el.articlesContainer?.dataset.filters ?? '{}');

function pagination() {
  Array.from(el.articlesContainer?.querySelectorAll('[data-element="pagination-link"]') ?? '').forEach(function (element) {

    if (element.dataset.eventPaginate) {
      return true;
    }

    element.dataset.eventPaginate = true;

    element.addEventListener('click', function (event) {

      event.preventDefault();

      element.dataset.page == 1 ? delete filters.page : filters.page = element.dataset.page;

      const url = constructUrl(el.path, filters, setUrlParameter);
      getArticles(url);

      el.articlesContainer?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });
}

function getArticles(url) {
  el.skeleton?.classList.add('active');

  fetch(url, {
    method: 'GET',
    mode: "cors",
    credentials: "same-origin",
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    }
  })
    .then(response => response.json())
    .then(function (result) {
      el.skeleton?.classList.remove('active');

      if (result.html && result.html.trim() !== '') {
        el.articlesContainer.innerHTML = result.html;
        lazyLoadBackgrounds('[data-bgimage');

        pagination();

        return true
      }

      /**
       * Set an error message when the source did not return any results
       */
      return el.articlesContainer.innerHTML = 'Sorry, the list is empty at the moment';
    })
    .catch(function (error) {
      el.skeleton?.classList.remove('active');
      return error ? el.articlesContainer.innerHTML = error : el.articlesContainer.innerHTML = 'Sorry, we were unable to load the information from the source'
    });

}

function constructUrl(path, filters, setURLfn) {
  if (Object.keys(filters).length) {
      Object.keys(filters).forEach(key => {
        if (key !== '_orderby') {
          path = setURLfn(path, key, filters[key]);
        }
      });
  }

  /**
   *  Използвайте pushState или hashchange за промяна на URL адреса при AJAX взаимодействия; 
   *  Но не и при смяна на ordering i direction
   */
    window.history.pushState({}, '', path);
  
    path = setURLfn(path, 'requested_via', 'ajax');

  return path
}

function setUrlParameter(uri, key, value) {

  let index = uri.indexOf('#');
  let fragment = index === -1 ? '' : uri.substring(index);
  uri = index === -1 ? uri : uri.substring(0, index);

  let expression = new RegExp("([?&])" + key + "=.*?(&|$)", "i");

  let separator = uri.indexOf('?') !== -1 ? "&" : "?";

  if (uri.match(expression)) {
    uri = uri.replace(expression, '$1' + key + "=" + value + '$2');
  } else {
    uri = uri + separator + key + "=" + value;
  }

  return uri + fragment;
}

document.addEventListener("DOMContentLoaded", () => {
    toolsSlider();
    schoolsSlider();
    careersSlider();
    testimonialsSlider();
    rankingSchoolsGrid();
    countriesSlider();
    fitTooltips();
    pagination();
//     customSelect({ removeItemButton: true });
    searchMBA();
    setAdBannersforMobOrDesk();
});